"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { mergeRefs } from "react-merge-refs";
import { useResizeObserver } from "usehooks-ts";
import {} from "../../types";
import { CheckCircle, Info, Warning } from "../Icon";
import s from "./Alert.module.css";
export const Alert = ({ color = "primary", variant = "outline", title, description, actions, actionsPlacement, indicator, className, actionsClassName, ref, ...restProps }) => {
    const containerRef = useRef(null);
    const actionsRef = useRef(null);
    const [actionsAutoPlacement, setActionsAutoPlacement] = useState("end");
    // @ts-expect-error -- Type issue in usehooks-ts
    const { width: containerWidth } = useResizeObserver({ ref: containerRef });
    useEffect(() => {
        const actionsWidth = actionsRef.current?.clientWidth ?? 0;
        if (actionsWidth && containerWidth) {
            // If actions are larger than a third of the container width, wrap them.
            const placement = actionsWidth > containerWidth / 3 ? "bottom" : "end";
            setActionsAutoPlacement(placement);
        }
    }, [containerWidth]);
    return (_jsxs("div", { ref: mergeRefs([ref, containerRef]), className: clsx(s.Alert, className), "data-variant": variant, "data-color": color, role: color === "danger" ? "alert" : undefined, "data-actions-placement": actionsPlacement ?? actionsAutoPlacement, ...restProps, children: [indicator === false ? null : (_jsx("div", { className: s.Indicator, children: indicator ?? _jsx(Indicator, { color: color }) })), _jsxs("div", { className: s.Content, children: [_jsxs("div", { className: s.Message, children: [title && _jsx("div", { className: s.Title, children: title }), description && _jsx("div", { className: s.Description, children: description })] }), actions && (_jsx("div", { className: clsx(s.Actions, actionsClassName), ref: actionsRef, children: actions }))] })] }));
};
export const Indicator = ({ color }) => {
    // Choose a default icon based on the color (which signals intention)
    switch (color) {
        case "warning":
        case "caution":
        case "danger":
            return _jsx(Warning, {});
        case "success":
            return _jsx(CheckCircle, {});
        default:
            return _jsx(Info, {});
    }
};
//# sourceMappingURL=Alert.js.map